import React from "react";
import s from './BasicPage.module.scss';
import BackButton from "../../common/BackButton";
import Button from "../../common/Button";
import {Key} from "../PianoKey";

interface IBasicPageProps {
  headerIcon?: string;
  headerIconComponent?: React.ReactNode; // If the icon is an SVG or other React component
  portraitModeHeaderText?: string;
  content: string | React.ReactNode;
  showBackButton?: boolean;
  actionButton?: IActionButton;
  useMosaicBackground?: boolean;
}

interface IActionButton {
  text: string;
  onClick: () => void;
  buttonType?: "primary" | "secondary";
  additionalClassName?: string;
  navigationNote?: Key | undefined;
}

export default function BasicPage({ headerIcon, headerIconComponent, portraitModeHeaderText, content, actionButton, useMosaicBackground = false, showBackButton = true }: IBasicPageProps) {
  let cssClasses = s.basicPageContainer;
  if (useMosaicBackground) {
    cssClasses += ` ${s.hasMosaicBackground}`;
  }

  return (
    <div className={cssClasses}>
      <header className={s.top}>
        {
          showBackButton
            ? <BackButton useClassName={s.backButton} />
            : null
        }
        {
          headerIcon
            ? <img className={s.headerIcon} src={headerIcon} width={56} height={56} alt='' loading={"eager"} />
            : null
        }
        {
          headerIconComponent
            ? headerIconComponent
            : null
        }
        {
          portraitModeHeaderText
            ? <div className={s.headerContent}>{portraitModeHeaderText}</div>
            : null
        }
      </header>
      <main className={s.mainContent}>
        {content}

        {
          actionButton
            ?
            <Button
              additionalClassName={s.actionButton}
              text={actionButton.text}
              onClick={actionButton.onClick}
              buttonType={actionButton.buttonType}
              navigationNote={actionButton.navigationNote}
            />
            :
            null
        }
      </main>
    </div>
  );
}
